import { Link } from 'react-router-dom';
import PlayCtaButton from '@/components/common/PlayCtaButton';
import PromoVideo from '@/components/common/PromoVideo';
import AppStoreBadge from '@/components/common/AppStoreBadge';
import PlayStoreBadge from '@/components/common/PlayStoreBadge';

export default function PlayFreeSection() {
  return (
    <section className="relative flex items-center justify-center px-6 py-24 sm:py-32 overflow-hidden bg-background/40">
      {/* Gold separator line */}
      <div
        className="absolute bottom-4 left-0 right-0 h-px"
        style={{
          background:
            'linear-gradient(to right, transparent, hsl(var(--accent-gold) / 0.3), transparent)',
        }}
      />

      <div className="relative z-10 flex flex-col items-center gap-8 max-w-5xl w-full text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-character text-foreground">
          Free to Start
        </h2>
        <div className="text-lg sm:text-xl font-medium text-foreground/70 leading-relaxed space-y-4">
          <p>Create an account and start playing in seconds. No invite code, no waiting.</p>
          <p>Your first adventures are on us: play free, then top up to keep going.</p>
          <p>
            Polymyth launches with an exclusive adventure module for players level 1–3, with more on
            the way.
          </p>
        </div>

        <PlayCtaButton label="Start Playing" />

        <PromoVideo className="max-w-2xl" />

        {/* Play on phone or tablet */}
        <div className="flex flex-col items-center gap-3 pt-8">
          <h3 className="text-2xl sm:text-3xl font-character text-foreground sm:whitespace-nowrap">
            Play on phone or tablet
          </h3>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <AppStoreBadge />
            <PlayStoreBadge />
          </div>
        </div>

        <p className="text-sm text-foreground/70">
          Already have an account?{' '}
          <Link to="/login" className="text-primary hover:underline font-medium">
            Sign in
          </Link>
        </p>
      </div>
    </section>
  );
}
